import axios from "axios";

// Override with REACT_APP_API_URL in .env (CRA picks it up at build time).
// Falls back to the production URL when unset so existing builds keep working.
const API_URL = process.env.REACT_APP_API_URL || 'https://app-ws.ipoptools.com';

// const token = localStorage.getItem("token");

axios.defaults.withCredentials = true;

const signin = (username: string, password: string) => {
    return axios
        .post(`${API_URL}/users/signin`, {
            username,
            password
        })
}

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    // withCredentials: true
})

const apiLogged = axios.create({
    baseURL: API_URL,
    // withCredentials: true
})

const authService = {
    signin,
    api,
    apiLogged
};

export default authService;